import { n as g, t as C, i as j, a as L, b as D, c as K, d as N } from "./index.DKoe20UO.js";
import { watch as R, ref as m, computed as S, reactive as P, getCurrentInstance as _, onMounted as I } from "vue";
function A(e) {
  var t;
  const n = C(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const O = N ? window : void 0;
function x(...e) {
  let t, n, r, d;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, r, d] = e, t = O) : [t, n, r, d] = e, !t)
    return g;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const s = [], v = () => {
    s.forEach((o) => o()), s.length = 0;
  }, p = (o, u, i, f) => (o.addEventListener(u, i, f), () => o.removeEventListener(u, i, f)), a = R(
    () => [A(t), C(d)],
    ([o, u]) => {
      if (v(), !o)
        return;
      const i = j(u) ? { ...u } : u;
      s.push(
        ...n.flatMap((f) => r.map((h) => p(o, f, h, i)))
      );
    },
    { immediate: !0, flush: "post" }
  ), l = () => {
    a(), v();
  };
  return L(l), l;
}
function V(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function Z(...e) {
  let t, n, r = {};
  e.length === 3 ? (t = e[0], n = e[1], r = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], r = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: d = O,
    eventName: s = "keydown",
    passive: v = !1,
    dedupe: p = !1
  } = r, a = V(t);
  return x(d, s, (o) => {
    o.repeat && C(p) || a(o) && n(o);
  }, v);
}
function $() {
  const e = m(!1), t = _();
  return t && I(() => {
    e.value = !0;
  }, t), e;
}
function W(e) {
  const t = $();
  return S(() => (t.value, !!e()));
}
function q(e, t, n = {}) {
  const { window: r = O, ...d } = n;
  let s;
  const v = W(() => r && "MutationObserver" in r), p = () => {
    s && (s.disconnect(), s = void 0);
  }, a = S(() => {
    const i = C(e), f = (Array.isArray(i) ? i : [i]).map(A).filter(K);
    return new Set(f);
  }), l = R(
    () => a.value,
    (i) => {
      p(), v.value && i.size && (s = new MutationObserver(t), i.forEach((f) => s.observe(f, d)));
    },
    { immediate: !0, flush: "post" }
  ), o = () => s == null ? void 0 : s.takeRecords(), u = () => {
    p(), l();
  };
  return L(u), {
    isSupported: v,
    stop: u,
    takeRecords: o
  };
}
function G(e, t, n = {}) {
  const { window: r = O, ...d } = n;
  let s;
  const v = W(() => r && "ResizeObserver" in r), p = () => {
    s && (s.disconnect(), s = void 0);
  }, a = S(() => Array.isArray(e) ? e.map((u) => A(u)) : [A(e)]), l = R(
    a,
    (u) => {
      if (p(), v.value && r) {
        s = new ResizeObserver(t);
        for (const i of u)
          i && s.observe(i, d);
      }
    },
    { immediate: !0, flush: "post" }
  ), o = () => {
    p(), l();
  };
  return L(o), {
    isSupported: v,
    stop: o
  };
}
function F(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: r = !0,
    windowScroll: d = !0,
    immediate: s = !0
  } = t, v = m(0), p = m(0), a = m(0), l = m(0), o = m(0), u = m(0), i = m(0), f = m(0);
  function h() {
    const w = A(e);
    if (!w) {
      n && (v.value = 0, p.value = 0, a.value = 0, l.value = 0, o.value = 0, u.value = 0, i.value = 0, f.value = 0);
      return;
    }
    const y = w.getBoundingClientRect();
    v.value = y.height, p.value = y.bottom, a.value = y.left, l.value = y.right, o.value = y.top, u.value = y.width, i.value = y.x, f.value = y.y;
  }
  return G(e, h), R(() => A(e), (w) => !w && h()), q(e, h, {
    attributeFilter: ["style", "class"]
  }), d && x("scroll", h, { capture: !0, passive: !0 }), r && x("resize", h, { passive: !0 }), D(() => {
    s && h();
  }), {
    height: v,
    bottom: p,
    left: a,
    right: l,
    top: o,
    width: u,
    x: i,
    y: f,
    update: h
  };
}
function ee(e, t = {}) {
  const {
    threshold: n = 50,
    onSwipe: r,
    onSwipeEnd: d,
    onSwipeStart: s,
    passive: v = !0,
    window: p = O
  } = t, a = P({ x: 0, y: 0 }), l = P({ x: 0, y: 0 }), o = S(() => a.x - l.x), u = S(() => a.y - l.y), { max: i, abs: f } = Math, h = S(() => i(f(o.value), f(u.value)) >= n), w = m(!1), y = S(() => h.value ? f(o.value) > f(u.value) ? o.value > 0 ? "left" : "right" : u.value > 0 ? "up" : "down" : "none"), k = (c) => [c.touches[0].clientX, c.touches[0].clientY], T = (c, b) => {
    a.x = c, a.y = b;
  }, B = (c, b) => {
    l.x = c, l.y = b;
  };
  let E;
  const z = H(p == null ? void 0 : p.document);
  v ? E = z ? { passive: !0 } : { capture: !1 } : E = z ? { passive: !1, capture: !0 } : { capture: !0 };
  const X = (c) => {
    w.value && (d == null || d(c, y.value)), w.value = !1;
  }, Y = [
    x(e, "touchstart", (c) => {
      if (c.touches.length !== 1)
        return;
      E.capture && !E.passive && c.preventDefault();
      const [b, M] = k(c);
      T(b, M), B(b, M), s == null || s(c);
    }, E),
    x(e, "touchmove", (c) => {
      if (c.touches.length !== 1)
        return;
      const [b, M] = k(c);
      B(b, M), !w.value && h.value && (w.value = !0), w.value && (r == null || r(c));
    }, E),
    x(e, ["touchend", "touchcancel"], X, E)
  ];
  return {
    isPassiveEventSupported: z,
    isSwiping: w,
    direction: y,
    coordsStart: a,
    coordsEnd: l,
    lengthX: o,
    lengthY: u,
    stop: () => Y.forEach((c) => c())
  };
}
function H(e) {
  if (!e)
    return !1;
  let t = !1;
  const n = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", g, n), e.removeEventListener("x", g), t;
}
export {
  x as a,
  F as b,
  Z as o,
  ee as u
};
//# sourceMappingURL=index.xeoxcFSu.js.map
